/** Header and rail utilities, user menus, project menus, agent hiring. */
export default {
  replayTour: "Replay tour",
  newProject: "New Project",
  themeDark: "Dark",
  themeLight: "Light",
  themeLabel: "Theme: {theme}",
  search: "Search",
  keyboardShortcuts: "Keyboard shortcuts",
  notifications: "Notifications",
  notificationsNew: "Notifications, {total} new",
  userMenu: "User menu",
  settings: "Settings",
  logOut: "Log out",
  profileMenu: "Profile menu",
  toggleMode: "Toggle Mode",
  textChat: "Text Chat",
  voiceChat: "Voice Chat",
  handsFreeVoice: "Hands-free Voice",
  rename: "Rename",
  setColor: "Set color",
  moveToProject: "Move to project",
  unpin: "Unpin",
  pinToTop: "Pin to top",
  projectSettings: "Project settings",
  delete: "Delete",
  availableAgents: "Available Agents",
  noAgentsAvailable: "No agents available",
  agentNamePlaceholder: "Agent name...",
  creating: "Creating...",
  create: "Create",
  createAgent: "Create Agent",
  agentSettings: "Agent Settings",
} as const;
